import { POSTAPI, generateHeader } from "../../../api-setup/api-helper";
import { GET_ALL_TASK_CATEGORY } from "../../../api-setup/api-endpoints";

// Fetch contract type list independently of locations
export const fetchContractTypeForProvider = async (cookiesData, providerId, dispatch) => {
  try {
    const apiHeaders = generateHeader();
    const requestBody = {
      in_tenant_id: cookiesData.out_tenant_id,
      in_user_id: cookiesData.out_user_id,
      in_sort_number: 2,
      in_sort_order: "ASC",
    };

    const response = await POSTAPI(false, GET_ALL_TASK_CATEGORY, null, apiHeaders, requestBody, dispatch);

    if (response?.data?.row_result && Array.isArray(response.data.row_result)) {
      const rawData = response.data.row_result;
      const transformedData = rawData.map((contractType) => ({
        id: contractType.task_category_mstr_key,
        text: contractType.name,
      }));

      return {
        success: true,
        // For filters in UI
        contractTypesForFilter: transformedData,
        // For any downstream detailed usage
        rawResponseData: [{ response }],
        count: transformedData.length,
      };
    } else {
      console.error("Failed to fetch contract type for provider:", response?.message || "Invalid response structure");
      return {
        success: false,
        contractTypesForFilter: [],
        count: 0,
        error: response?.message || "Invalid response structure",
      };
    }
  } catch (error) {
    console.error("Error fetching contract type for provider:", error);
    return {
      success: false,
      contractTypesForFilter: [],
      count: 0,
      error: error.message,
    };
  }
};
